import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "./Reveal";

const LINKS = [
  { id: "approach", label: "Approach" },
  { id: "services", label: "Services" },
  { id: "framework", label: "Care Framework" },
  { id: "vision", label: "Vision" },
  { id: "contact", label: "Contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <motion.header
      data-testid="header-navigation-bar"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow,padding] duration-500 ${scrolled ? "bg-[#F6F4EE]/80 backdrop-blur-xl shadow-[0_1px_0_rgba(14,77,68,0.08)] py-3" : "py-5"}`}
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12 flex items-center justify-between">
        <button data-testid="nav-logo-link" onClick={() => go("top")} aria-label="Welcon home"><Logo /></button>
        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <button key={l.id} data-testid={`nav-${l.id}-link`} onClick={() => go(l.id)} className="nav-link text-sm text-[#22413B]">
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <div className="hidden sm:block">
            <button data-testid="nav-book-consultation-btn" onClick={() => go("book")} className="btn-primary">
              Book a consultation <ArrowUpRight className="h-4 w-4" />
            </button>
          </div>
          <button data-testid="nav-mobile-menu-btn" onClick={() => setOpen((v) => !v)} className="lg:hidden h-11 w-11 rounded-full border border-[#0E4D44]/20 grid place-items-center text-[#0E4D44]" aria-label="Menu">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="nav-mobile-panel"
            initial={{ opacity: 0, y: -12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }}
            className="lg:hidden mx-4 mt-3 rounded-3xl bg-[#F6F4EE] border border-[#0E4D44]/10 shadow-xl p-6 flex flex-col gap-4"
          >
            {LINKS.map((l) => (
              <button key={l.id} data-testid={`nav-mobile-${l.id}-link`} onClick={() => go(l.id)} className="text-left font-display text-2xl text-[#0B2B26]">{l.label}</button>
            ))}
            <button data-testid="nav-mobile-book-btn" onClick={() => go("book")} className="btn-primary justify-center mt-2">Book a consultation</button>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
